import React from "react";
import { Progress, Button } from "reactstrap";
import "./progressBar.scss";

function ProgressBar(props) {
  const { progress, onClose, time } = props;
  const { minutes: m, seconds: s } = time;
  const timeString = `${m}:${s < 10 ? "0" : ""}${s}`;

  return (
    <div className="progress-header">
      <Button onClick={onClose} className="btn-icon">
        <img alt="Back" src="/img/icons/back.svg" />
      </Button>
      <Progress
        className="round-progress"
        barClassName="round-progress-bar"
        value={100 * progress || 0}
      />
      <div className="progress-header-time">{timeString}</div>
    </div>
  );
}

export { ProgressBar };
